// extracted by mini-css-extract-plugin
export default {"mCard":"RA-z","image":"SA-z","imageNoBackground":"TA-z","imageHasCategory":"UA-z","fullWidth":"VA-z"};